module.exports = "@media (min-width: 576px){.sect-header.no-header-border{text-align:left;border:0}}\n.type-label{padding-left:0;padding-right:0}\n"